import MinaSidorLayout from '@/views/Layout/MinaSidorLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/admin/logout',
    alias: "/en/admin/logout",
    name: 'logout',
    component: () => import(/* webpackChunkName: "demo" */ '../views/logout.vue')
  },
  {
    path: '/en/admin',
    redirect: '/en/admin/mina_sidor',
  },
  {
    path: '/admin',
    redirect: '/admin/mina_sidor',
    component: MinaSidorLayout,
    children: [
      {
        path: '/admin/mina_sidor',
        alias: "/en/admin/mina_sidor",
        name: 'mina_sidor',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Mina_Sidor.vue')
      },
      {
        path: '/admin/mina_sidor/order/:id',
        alias: "/en/admin/mina_sidor/order/:id",
        name: 'order_detail',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Order_Details.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/admin/login',
        alias: "/en/admin/login",
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/admin/register',
        alias: "/en/admin/register",
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      },
      {
        path: '/admin/reset',
        alias: "/en/admin/reset",
        name: 'reset',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Reset.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
